var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TinyMCE',{model:{value:(_vm.curComponent.propValue),callback:function ($$v) {_vm.$set(_vm.curComponent, "propValue", $$v)},expression:"curComponent.propValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }